// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2rtqM","col":"Table_col__1BVSk","fulfillmentStatus":"Table_fulfillmentStatus__27X-x","emailCol":"Table_emailCol__13wFo"};